import React from 'react';
import { FormField, NumberInput, InputAdornment } from '@cian/ui-kit';

import { INumberInputProps } from '../../types';

export const InputNumberField: React.FC<INumberInputProps> = ({
  label,
  value,
  name,
  onChange,
  testId = `field-${name}`,
  placeholder,
  required,
  disabled,
  decimalDigits,
  rightAdornment,
  min,
  max,
}) => {
  return (
    <FormField label={label} required={required} dataTestId={testId} withoutMargin>
      <NumberInput
        data-testid={name}
        decimalDigits={decimalDigits || 0}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        name={name}
        size="M"
        rightAdornment={<InputAdornment>{rightAdornment}</InputAdornment>}
        min={min}
        max={max}
      />
    </FormField>
  );
};

InputNumberField.displayName = 'InputNumberField';
